import { Skeleton } from "src/atoms/Skeleton";
import { Box, Flex } from "@otrium/core";
import { Container } from "src/atoms/Container";
import { ProductCardSkeleton } from "src/molecules/ProductCardSkeleton";

const CardsRowSkeleton = () => (
  <Flex mx={-2}>
    {[...(Array(3) as number[])].map((_value, index) => (
      <Box key={index} px={2} py={2} width={1 / 3}>
        <ProductCardSkeleton />
      </Box>
    ))}
  </Flex>
);

const ProductsViewSkeleton = (): JSX.Element => (
  <Container>
    <Flex flexWrap="wrap" mt={2}>
      <Box width={"200px"} height="20px">
        <Skeleton />
      </Box>
      <Box ml={2} width={"45px"} height="20px">
        <Skeleton />
      </Box>
      <Box ml={2} width={"45px"} height="20px">
        <Skeleton />
      </Box>
    </Flex>
    <Flex mt={2} width={"150px"} height="35px">
      <Skeleton />
    </Flex>
    <Flex flexWrap="wrap" mx={-2}>
      <Box
        px={2}
        py={2}
        width={[0, 0, 0, 1 / 4, 1 / 4]}
        display={["none", "none", "block", "block"]}
      >
        <Box sx={{ height: "35px" }} pb={2}>
          <Skeleton />
        </Box>
        <Flex px={2} mx={-2}>
          <Box sx={{ height: "25px" }} width={1 / 8} mr={1} pl={1} pb={2}>
            <Skeleton />
          </Box>
          <Box sx={{ height: "25px" }} width={1} pl={1} pb={2}>
            <Skeleton />
          </Box>
        </Flex>
        {[...(Array(10) as number[])].map((_value, index) => (
          <Flex key={`skeleton-line-${index}`} px={2} pl={4} mx={-2}>
            <Box sx={{ height: "25px" }} width={1 / 8} mr={1} pl={1} pb={2}>
              <Skeleton />
            </Box>
            <Box sx={{ height: "25px" }} width={1} pl={1} pb={2}>
              <Skeleton />
            </Box>
          </Flex>
        ))}
      </Box>
      <Box width={3 / 4}>
        <CardsRowSkeleton />
        <CardsRowSkeleton />
      </Box>
    </Flex>
  </Container>
);

export default ProductsViewSkeleton;
